/**
 * Print page alignment helpers (was print.js).
 */
function setMargins(left, right) {
    document.querySelectorAll('.page').forEach((p) => {
        p.style.marginLeft = left;
        p.style.marginRight = right;
    });
}

export function centerAlign() {
    setMargins('auto', 'auto');
    document.body.setAttribute('data-align', 'center');
}

export function leftAlign() {
    document.body.setAttribute('data-align', 'left');
    setMargins('0', 'auto');
}

export function rightAlign() {
    document.body.setAttribute('data-align', 'right');
    setMargins('auto', '0');
}
